import React, { Dispatch, SetStateAction, useMemo } from "react";
import { Link } from "react-router-dom";
import { encryptId } from "../../../../_metronic/helpers";
import { Collaborator } from "app/types/collaborator";
import TableComponent from "app/components/TableComponent";

type Props = {
  data: Collaborator[];
  loadingGrid: boolean;
  totalRecords: number;
  pageSize: number;
  page: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
};

const ListGrid: React.FC<Props> = ({
  data,
  loadingGrid,
  totalRecords,
  pageSize,
  page,
  setCurrentPage,
}) => {
  const columns: any = [
    {
      code: "tipo",
      label: <div className="fw-bolder text-muted" style={{ textAlign: "left"  }}>Tipo</div>,
    },
    {
      code: "nombre",
      label: <div className="fw-bolder text-muted" style={{ width: 170, margin: "0 auto" ,textAlign: "left"}}>Nombre</div>,
    },  
    {
      code: "perfil",
      label: <div className="fw-bolder text-muted" style={{ width: 150, margin: "0 auto" ,textAlign: "left"  }}>Perfil asociado</div>,
    },
    {
      code: "departamento",
      label: <div className="fw-bolder text-muted" style={{margin: "0 auto" ,textAlign: "left" }}>Departamento</div>,
    },
    {
      code: "telefono",
      label: <div className="fw-bolder text-muted" style={{ width: 80, margin: "0 auto" ,textAlign: "left" }}>Celular</div>,
    },
    {
      code: "contactoEmergencia",
      label: <div className="fw-bolder text-muted" style={{ width: 120, margin: "0 auto" ,textAlign: "left" }}>Contacto Emergencia</div>,
    },
    {
      code: "telefonoEmergencia",
      label: <div className="fw-bolder text-muted" style={{ width: 80, margin: "0 auto" ,textAlign: "left" }}>Tel. Emergencia</div>,
    },
    {
      code: "etapa",
      label: <div className="fw-bolder text-muted" style={{margin: "0 auto" ,textAlign: "left" }}>Etapa</div>,
    },
    {
      code: "estado",
      label: <div className="fw-bolder text-muted" style={{ width: 110, margin: "0 auto" ,textAlign: "left" }}>Estado</div>,
    },
  ];

const rows = useMemo(() => {
  if (!loadingGrid && data.length) {
    return data.map((row) => ({
      tipo: <div style={{ textAlign: "left" }}>{row.typeCollaborator || "No registrado"}</div>,
      nombre: (
        <div style={{ textAlign: "left" }}>
        <Link
          to={`/recursos_humanos/colaboradores/edit/${encryptId(
            row.id?.toString() || ""
          )}`}
          style={{ textAlign: "left" }}
        >
          {row.fullName || "No registrado"}
        </Link>
        </div>
      ),
      perfil: <div style={{ textAlign: "left" }}>{row.perfil || "No registrado"}</div>,
      departamento: <div style={{ textAlign: "left" }}>{row.departamento || "No registrado"}</div>,
      telefono: <div style={{ textAlign: "left" }}>{row.cellular || "No registrado"}</div>,
      contactoEmergencia: <div style={{ textAlign: "left" }}>{row.emergencyFullName || "No registrado"}</div>,
      telefonoEmergencia: <div style={{ textAlign: "left" }}>{row.emergencyPhone || "No registrado"}</div>,
      etapa: <div style={{ textAlign: "left" }}>{row.stateProccess || "No registrado"}</div>,
      estado: (
        <div
          style={{ textAlign: "left" }}
          className={
            row.status === "ACTIVO"
              ? "estado-activo"
              : row.status === "EN PROCESO"
                ? "estado-proceso"
                : row.status === "BAJA"
                  ? "estado-baja"
                  : ""
          }
        >
          {row.status || "No registrado"}
        </div>
      ),
    }));
  }
  return [];
}, [data, loadingGrid]);
  return (
    <div className={`row`}>
      <div className="col-xl-12">
        <div className={`card mb-0 mb-xxl-8 w-100`}>
          <TableComponent
            heads={columns} rows={rows}
            rowsPerPage={pageSize}
            page={page}
            totalRows={totalRecords}
            setPage={setCurrentPage}
            height="90%"
          />
        </div>
      </div>
    </div>
  );
};

export { ListGrid };
